import { ONE_HUNDRED_PERCENT } from '../../constants';

export const getDiscountedPrice = (originalPrice: number, markdownPercentage: number) =>
  Math.ceil((originalPrice * (ONE_HUNDRED_PERCENT - markdownPercentage)) / ONE_HUNDRED_PERCENT);
